import { Component, DestroyRef, Inject, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '@core/services/api/api.service';

export interface ApiCredentialDialogConfig {
  integrationDisplayName: string;
  fieldLabel: string;
  fieldName: string;
  helperText: string;
  validatePath: string;
  placeholder?: string;
}

@Component({
  selector: 'api-credential-dialog',
  templateUrl: './api-credential-dialog.component.html',
  styleUrls: ['./api-credential-dialog.component.scss'],
  standalone: false,
})
export class ApiCredentialDialogComponent {
  value: string = '';
  submitting: boolean = false;
  errorMessage: string = '';

  private destroyRef = inject(DestroyRef);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ApiCredentialDialogConfig,
    public dialogRef: MatDialogRef<ApiCredentialDialogComponent, string | null>,
    private apiService: ApiService,
  ) {}

  cancel(): void {
    this.dialogRef.close(null);
  }

  submit(): void {
    this.value = this.value.trim();
    if (!this.value || this.submitting) return;

    this.submitting = true;
    this.errorMessage = '';

    const body = { [this.data.fieldName]: this.value };

    this.apiService
      .post(this.data.validatePath, body)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.submitting = false;
          this.dialogRef.close(this.value);
        },
        error: (err) => {
          this.submitting = false;
          // routes answer either {error: '...'} or a bare text body
          this.errorMessage =
            err?.error?.error ||
            (typeof err?.error === 'string' ? err.error : '') ||
            `Failed to validate ${this.data.fieldLabel}`;
        },
      });
  }
}
